import PaymentProvider from "@models/payment-provider";
import axios, { AxiosInstance } from "axios";

export default class PaymentsAPI {
  private readonly client: AxiosInstance;

  constructor() {
    this.client = axios.create({
      baseURL: process.env.REACT_APP_PAYMENTS_API_URL,
    });
  }

  async getPaymentProviders(partnerId: string) {
    const res = await this.client.get<any[]>("/v1/payments/providers", {
      params: {
        partner_id: partnerId,
        order_type: "store",
      },
    });
    return res.data.map((data) => new PaymentProvider(data));
  }
}
